import { createAsyncThunk } from '@reduxjs/toolkit';
import { DELIVERY_SALE_TYPES } from '../constants/saleType';
import lodash from 'lodash';
import Logger from '../utils/Logger';
import Api, { AuthenticationMethod, FetchParams } from '../utils/Api';
import { FAILURE_REASON } from '../constants';
import { constructSalePaymentRequest } from '../thunks/constructSalePaymentRequest';
import { IDeliveryDropOffCoordinatesHttpDto, IDeliveryFeeCalculateRequestDto } from '../dtos/interfaces';
import { buildDeliveryRequestContent } from '../utils/ordering/buildDeliveryRequestContent';
interface FetchDeliveryFeeDto {
  authenticationMethod?: AuthenticationMethod;
  readonly deliveryDropOffCoordinates?: IDeliveryDropOffCoordinatesHttpDto;
  readonly customAddress?: string;
  readonly customSuburb?: string;
  readonly customPostCode?: string;
}

export const fetchDeliveryFee = createAsyncThunk(
  '$fetchDeliveryFee',
  async (data: FetchDeliveryFeeDto, { dispatch, rejectWithValue }) => {
    const {
      authenticationMethod = 'trusted',
      deliveryDropOffCoordinates,
      customAddress,
      customSuburb,
      customPostCode,
    } = data;
    let response;
    let valid = false;
    let errorText: string = '';
    try {
      let body: any = {};

      const { body: saleBody } = await dispatch(
        constructSalePaymentRequest({
          route: 'checkout',
          authenticationMethod,
        }),
      ).unwrap();
      body = saleBody;

      const isDeliverySale = DELIVERY_SALE_TYPES.includes(body.SaleType);

      const { deliverySaleCoordinatesContent, customAddressContent } =
        buildDeliveryRequestContent({
          isDeliverySale,
          deliveryDropOffCoordinates,
          existingAddress: body.Address,
          customAddress,
          customSuburb,
          customPostCode,
        });

      const requestBody: IDeliveryFeeCalculateRequestDto = {
        ...body,
        ...deliverySaleCoordinatesContent,
        ...customAddressContent,
      };

      const params: FetchParams = {
        path: '/api/v1/sale/delivery-fee/calculate',
        method: 'POST',
        body: requestBody,
        applicationErrorAllowed: true,
      };

      response = await Api.fetch(params, authenticationMethod);
      Logger.log(`delivery fee response: ${JSON.stringify(response)}`);
      valid = response.success;
      if (!valid) {
        throw new Error(response.error);
      }

      return {
        deliveryFee: response?.data.delivery_fee,
        discountedDeliveryFee: response?.data.discounted_delivery_fee,
      };

    } catch (e) {
      console.error('fetch delivery fee failed', e);
      return rejectWithValue({
        e,
        reason:
          lodash.get(e, 'details.type', '' as string) === 'connectivity'
            ? FAILURE_REASON.FETCH_FAILED
            : undefined,
        errorText,
      });
    }
  },
);
